export const FloodForecastConstants = {
  POINTTOBASINMAPPING: {
    godavariBasin: [
      'Kunavaram_FFS',
      'Koida FFS',
      'Polavaram Project',
      'Tallapudi_RR_FFS',
      'SIR AURTHUR COTTON BARRAGE',
      'Konta FFS 2',
      'Konta FFS',
      'N.M. WEIR',
      'JAIKWADI',
      'NANDED FFS',
      'DEGLOOR FFS',
      'Nizam Sagar Project',
      'Pothangal FFS',
      'Tekra FFS',
      'Pathagudem FFS',
      'Sri Ram Sagar Project',
      'Sri Pada Yellampalli Project',
      'Mancherial FFS',
      'Kaleshwaram FFS',
      'Perur FFS',
      'TALIPERU DAM',
      'Bhadrachalam FFS',
    ],

    krishnaBasin: [
      'RMC-PEDAKADIMI Bridge',
      'Tungabadra AP border',
      'Holagunda_FFS',
      'G.SINGAVARAM_FFS',
      'Lakshmipuram_FFS',
      'Santhanikota_FFS',
      'SRISAILAM R',
      'NAGARJUNA SAGAR',
      'Pondugula_FFS',
      'PULICHINTHALA PROJECT',
      'Paleru Bridge-Garikapadu',
      'Polampalli_FFS',
      'Muniyeru-Penuganchiprolu bridge',
      'Kattaleru Bridge-Chinthalapdu',
      'Keesara_FFS',
      'PRAKASAM BARRAGE',
      'ALMATTI',
      'NARAYANAPUR',
      'UJJAINI',
      'JURALA',
      'K. Agraharam_FFS',
      'Yaparla_FFS 2',
      'Yaparla_FFS',
      'Halia_FFS',
      'Damaracherla_FFS',
      'Madhira_FFS',
      'Myaliganur FFS',
      'Daund',
      'Yadgir FFS',
      'Chainage 5.2 km of Patiseema RMC',
      'Huvinhedigi',
      'Deosugur',
      'NANDRE',
      'KURUNDWAD',
      'Gokak Falls',
      'Cholachguda',
      'SUNKESULA BARRAGE',
      'Ravirala FFS',
      'Rudravaram FFS',
      'Vellaturu FFS',
      'Downstream of Thammileru acquiduct',
      'Downstream of Nunna bed Regulator',
      'Amaravathi Town FFS',
      'Tummalapalem FFS',
      'RMC-Budameru Regulator',
    ],

    ap: [
      'Karani_FFS',
      'Suratpalle_FFS',
      'Boddabada_FFS',
      'KOTHULAWAGU THADIGUDEM',
      'Kothulawagu bridge-Chinnanandigama',
      'BUDAMERU MYLAVARAM VELVADAM BRIDGE',
      'PULIVAGU GANGINENI BRIDGE',
      'Nandigam_FFS',
      'Kunavaram_FFS',
      'Koida FFS',
      'Polavaram Project',
      'Tallapudi_RR_FFS',
      'SIR AURTHUR COTTON BARRAGE',
      'Nagarapalem_R_FFS',
      'Marella_R_FFS',
      'Ulichi_FFS',
      'Sullurpeta_FFS',
      'Gouravaram_FFS',
      'Alladapalem_FFS',
      'Sathravada_FFS',
      'RMC-PEDAKADIMI Bridge',
      'Holagunda_FFS',
      'G.SINGAVARAM_FFS',
      'Lakshmipuram_FFS',
      'Santhanikota_FFS',
      'SRISAILAM R',
      'NAGARJUNA SAGAR',
      'Pondugula_FFS',
      'PULICHINTHALA PROJECT',
      'Paleru Bridge-Garikapadu',
      'Polampalli_FFS',
      'Muniyeru-Penuganchiprolu bridge',
      'Kattaleru Bridge-Chinthalapdu',
      'Keesara_FFS',
      'PRAKASAM BARRAGE',
      'Pamuru_FFS',
      'Manneti Kota_FFS',
      'Chepaluppada (Thikkavari-Palem)_FFS',
      'Mukthinutala Padu_FFS',
      'Tangutur_FFS',
      'Thammunaidupeta (Kallepalli)_FFS',
      'Fazulbegpeta_FFS',
      'Pedagadi_R_FFS',
      'Kalikiri_FFS',
      'K.Bitragunta_FFS',
      'Annavaram_RR_FFS',
      'Tamada Village_FFS',
      'Nagalamedike_FFS (AP Border)',
      'PENNA AHOBILAM BALANCING RESERVOIR',
      'MID PENNAR RESERVOIR',
      'Tadipatri_FFS',
      'Sankepalle_FFS',
      'Singavaram_FFS',
      'Gandlur_FFS',
      'MYLAVARAM(PENNAR) RESERVOIR',
      'Kamalapuram_FFS',
      'Alladupalle_FFS',
      'Yettur_FFS',
      'Chennur_FFS',
      'Totigari Palli_FFS',
      'Nandipalli_FFS',
      'Kongalaveedu_FFS',
      'Somasila Reservoir',
      'Nellore_FFS',
      'Kangundi_FFS',
      'Gudipadu_R_FFS',
      'Kadavakuduru_FFS',
      'Anakapalle_R_FFS',
      'Vakapadu_FFS',
      'Ponnada (Nagalapalli)_FFS',
      'Naidupet_R_FFS',
      'Marlupalli_FFS',
      'Jogannapalem_R_FFS',
      'Tuni_R_FFS',
      'Guduru_RR_FFS',
      'Neradi_B_RR_FFS',
      'Kashinagar_FFS',
      'Korswada_FFS',
      'GOTTA BARRAGE',
      'Gunupur_FFS',
      'Darlapudi (Yettikapoka)_R_FFS',
      'Achampeta Road_FFS',
      'Somavaram_R_FFS',
      'Madavaram_R_FFS',
      'Myaliganur FFS',
      'SUNKESULA BARRAGE',
      'Ravirala FFS',
      'Rudravaram FFS',
      'Vellaturu FFS',
      'Chainage 5.2 km of Patiseema RMC',
      'Downstream of Thammileru acquiduct',
      'Downstream of Nunna bed Regulator',
      'RMC-Budameru Regulator',
      'Amaravathi Town FFS',
      'Tummalapalem FFS',
    ],
  },
  POINTOFINTEREST: {
    southZone: [
      'UJJAINI',
      'ALMATTI',
      'NARAYANAPUR',
      'NARAYANAPUR',
      'JURALA',
      'Tungabadra AP border',
      'SRISAILAM R',
      'NAGARJUNA SAGAR',
      'PRAKASAM BARRAGE',
      'Sri Ram Sagar Project',
      'SIR AURTHUR COTTON BARRAGE',
      'GOTTA BARRAGE',
      'Somasila Reservoir',
    ],

    godavariBasin: [
      'JAIKWADI',
      'NANDED FFS',
      'Nizam Sagar Project',
      'Sri Ram Sagar Project',
      'Sri Pada Yellampalli Project',
      'Bhadrachalam FFS',
      'Polavaram Project',
      'SIR AURTHUR COTTON BARRAGE',
    ],

    krishnaBasin: [
      'ALMATTI',
      'NARAYANAPUR',
      'Tungabadra AP border',
      'JURALA',
      'SUNKESULA BARRAGE',
      'SRISAILAM R',
      'NAGARJUNA SAGAR',
      'PULICHINTHALA PROJECT',
      'RMC-PEDAKADIMI Bridge',
      'PRAKASAM BARRAGE',
    ],

    ap: [
      'SUNKESULA BARRAGE',
      'SRISAILAM R',
      'NAGARJUNA SAGAR',
      'PRAKASAM BARRAGE',
      'SIR AURTHUR COTTON BARRAGE',
      'GOTTA BARRAGE',
      'PENNA AHOBILAM BALANCING RESERVOIR',
      'MID PENNAR RESERVOIR',
      'MYLAVARAM(PENNAR) RESERVOIR',
      'Somasila Reservoir',
      'RMC-PEDAKADIMI Bridge',
    ],
  },
  // REGIONOFINTEREST: [
  //   {
  //     regionName: 'South Zone',
  //     value: 'southZone'
  //   },
  //   {
  //     regionName: 'Andhra Pradesh',
  //     value: 'ap'
  //   },
  //   {
  //     regionName: 'Godavari Basin',
  //     value: 'godavariBasin'
  //   },
  //   {
  //     regionName: 'Godavari HEC-HMS',
  //     value: 'godavari_hec_hms'
  //   },
  //   {
  //     regionName: 'Krishna Basin',
  //     value: 'krishnaBasin'
  //   },
  //   {
  //     regionName: 'Pennar Basin',
  //     value: 'pennarBasin'
  //   },
  //   {
  //     regionName: 'Vamsadhara Basin',
  //     value: 'vamsadharaBasin'
  //   },
  //   {
  //     regionName: 'Nagavali Basin',
  //     value: 'nagavaliBasin'
  //   }
  // ],
  REGIONOFINTEREST: [
    {
      regionName: 'South Zone',
      value: 'southZone'
    },
    // {
    //   regionName: 'Andhra Pradesh',
    //   value: 'ap'
    // },
    // {
    //   regionName: 'Godavari Basin',
    //   value: 'godavariBasin'
    // },
    // {
    //   regionName: 'Godavari HEC-HMS',
    //   value: 'godavari_hec_hms'
    // },
    // {
    //   regionName: 'Krishna Basin',
    //   value: 'krishnaBasin'
    // },
    // {
    //   regionName: 'Pennar Basin',
    //   value: 'pennarBasin'
    // },
    // {
    //   regionName: 'Vamsadhara Basin',
    //   value: 'vamsadharaBasin'
    // },
    // {
    //   regionName: 'Nagavali Basin',
    //   value: 'nagavaliBasin'
    // },
    // {
    //   regionName: 'Mahanadi Basin',
    //   value: 'MahanadiBasin'
    // },
    // {
    //   regionName: 'Cauvery Basin',
    //   value: 'CauveryBasin'
    // },
  ],
  REGIONOFINTEREST1: [
    // {
    //   regionName: 'South Zone',
    //   value: 'southZone'
    // },
    // {
    //   regionName: 'Andhra Pradesh',
    //   value: 'ap'
    // },
    {
      regionName: 'Godavari Basin',
      value: 'godavariBasin'
    },
    {
      regionName: 'Godavari HEC-HMS',
      value: 'godavari_hec_hms'
    },
    {
      regionName: 'Krishna Basin',
      value: 'krishnaBasin'
    },
    {
      regionName: 'Pennar Basin',
      value: 'pennarBasin'
    },
    {
      regionName: 'Vamsadhara Basin',
      value: 'vamsadharaBasin'
    },
    {
      regionName: 'Nagavali Basin',
      value: 'nagavaliBasin'
    },
    {
      regionName: 'Mahanadi Basin',
      value: 'MahanadiBasin'
    },
    {
      regionName: 'Cauvery Basin',
      value: 'CauveryBasin'
    },
  ],
  BASINREGION: {
    'southZone': 'totalReservoirs',
    'ap': 'totalReservoirs',
    'godavariBasin': 'GODAVARI',
    'godavari_hec_hms': 'GODAVARI',
    'krishnaBasin': 'Krishna',
    'pennarBasin': 'PENNAR',
    'vamsadharaBasin': 'Other',
    'nagavaliBasin': 'Other'
  },
  BASINREGIONDISPLAY: {
    'southZone': 'South Zone',
    'ap': 'Andhra Pradesh',
    'godavariBasin': 'Godavari Basin',
    'godavari_hec_hms': 'Godavari HEC-HMS',
    'krishnaBasin': 'Krishna Basin',
    'pennarBasin': 'Pennar Basin',
    'vamsadharaBasin': 'Vamsadhara Basin',
    'nagavaliBasin': 'Nagavali Basin',
    'MahanadiBasin': 'Mahanadi Basin',
    'CauveryBasin': 'Cauvery Basin',
  }
};
